// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

//region Solid icons
import {
  faSignature as faSignatureSolid,
  faCakeCandles as faCakeCandlesSolid,
  faMailbox as faMailboxSolid,
  faEarthEurope as faEarthEuropeSolid,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareSolid,
  faThumbsUp as faThumbsUpSolid,
  faArrowsUpDownLeftRight as faArrowsUpDownLeftRightSolid,
  faArrowUpRightAndArrowDownLeftFromCenter as faArrowUpRightAndArrowDownLeftFromCenterSolid,
  faCrosshairsSimple as faCrosshairsSimpleSolid,
  faAddressBook as faAddressBookSolid,
  faAddressCard as faAddressCardSolid,
  faArrowPointer as faArrowPointerSolid,
  faThumbsDown as faThumbsDownSolid,
  faAlarmClock as faAlarmClockSolid,
  faArrowRight as faArrowRightSolid,
  faRotate as faRotateSolid,
  faArrowsRepeat as faArrowsRepeatSolid,
  faArrowTurnLeft as faArrowTurnLeftSolid,
  faBell as faBellSolid,
  faCalendarExclamation as faCalendarExclamationSolid,
  faCaretDown as faCaretDownSolid,
  faCarGarage as faCarGarageSolid,
  faChartLineUp as faChartLineUpSolid,
  faChartNetwork as faChartNetworkSolid,
  faCheck as faCheckSolid,
  faCreditCard as faCreditCardSolid,
  faFileCheck as faFileCheckSolid,
  faPenToSquare as faPenToSquareSolid,
  faUserXmark as faUserXmarkSolid,
  faCheckSquare as faCheckSquareSolid,
  faChevronDown as faChevronDownSolid,
  faUserLock as faUserLockSolid,
  faChevronUp as faChevronUpSolid,
  faChurch as faChurchSolid,
  faCircle as faCircleSolid,
  faCircleDot as faCircleDotSolid,
  faCalendarPen as faCalendarPenSolid,
  faCircleCheck as faCircleCheckSolid,
  faCircleInfo as faCircleInfoSolid,
  faPlay as faPlaySolid,
  faBan as faBanSolid,
  faCirclePlay as faCirclePlaySolid,
  faCircleStop as faCircleStopSolid,
  faCircleQuestion as faCircleQuestionSolid,
  faCity as faCitySolid,
  faClock as faClockSolid,
  faClone as faCloneSolid,
  faCoffin as faCoffinSolid,
  faTimer as faTimerSolid,
  faCommand as faCommandSolid,
  faCommentQuestion as faCommentQuestionSolid,
  faCopy as faCopySolid,
  faCross as faCrossSolid,
  faDiamondTurnRight as faDiamondTurnRightSolid,
  faDownload as faDownloadSolid,
  faDrone as faDroneSolid,
  faEllipsis as faEllipsisSolid,
  faEnvelope as faEnvelopeSolid,
  faEnvelopeCircle as faEnvelopeCircleSolid,
  faEuroSign as faEuroSignSolid,
  faExchangeAlt as faExchangeAltSolid,
  faEye as faEyeSolid,
  faEyeSlash as faEyeSlashSolid,
  faFilePlus as faFilePlusSolid,
  faSlashForward as faSlashForwardSolid,
  faCircleEuro as faCircleEuroSolid,
  faClipboardCheck as faClipboardCheckSolid,
  faEnvelopeCircleCheck as faEnvelopeCircleCheckSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faFaceSmile as faFaceSmileSolid,
  faFamily as faFamilySolid,
  faFeather as faFeatherSolid,
  faFileContract as faFileContractSolid,
  faFileLines as faFileLinesSolid,
  faFilePen as faFilePenSolid,
  faFilter as faFilterSolid,
  faFireplace as faFireplaceSolid,
  faFireFlameSimple as faFireFlameSimpleSolid,
  faFolderBookmark as faFolderBookmarkSolid,
  faGears as faGearsSolid,
  faHotel as faHotelSolid,
  faFlower as faFlowerSolid,
  faHourglassClock as faHourglassClockSolid,
  faHourglassStart as faHourglassStartSolid,
  faHouseBlank as faHouseBlankSolid,
  faHouseNight as faHouseNightSolid,
  faImage as faImageSolid,
  faIdCard as faIdCardSolid,
  faListCheck as faListCheckSolid,
  faLock as faLockSolid,
  faLockOpen as faLockOpenSolid,
  faLocationDot as faLocationDotSolid,
  faLocationPin as faLocationPinSolid,
  faMessageCheck as faMessageCheckSolid,
  faMicrophone as faMicrophoneSolid,
  faEnvelopeOpen as faEnvelopeOpenSolid,
  faEnvelopeDot as faEnvelopeDotSolid,
  faTriangleExclamation as faTriangleExclamationSolid,
  faMug as faMugSolid,
  faNewspaper as faNewsPaperSolid,
  faPaperclip as faPaperClipSolid,
  faPaperPlane as faPaperPlaneSolid,
  faPen as faPenSolid,
  faPeopleArrows as faPeopleArrowsSolid,
  faPeopleCarryBox as faPeopleCarryBoxSolid,
  faPhone as faPhoneSolid,
  faPhoneArrowUpRight as faPhoneArrowUpRightSolid,
  faPhoneOffice as faPhoneOfficeSolid,
  faUserCheck as faUserCheckSolid,
  faPiggyBank as faPiggyBankSolid,
  faPlaneDeparture as faPlaneDepartureSolid,
  faPlus as faPlusSolid,
  faPrint as faPrintSolid,
  faReply as faReplySolid,
  faRingsWedding as faRingsWeddingSolid,
  faShovel as faShovelSolid,
  faSpinner as faSpinnerSolid,
  faSlidersUp as faSliderUpSolid,
  faStar as faStarSolid,
  faStarOfLife as faStarOfLifeSolid,
  faSteeringWheel as faSteeringWheelSolid,
  faTag as faTagSolid,
  faTags as faTagsSolid,
  faTimes as faTimesSolid,
  faTimesCircle as faTimesCircleSolid,
  faTombstone as faTombstoneSolid,
  faTrash as faTrashSolid,
  faTrashUndo as faTrashUndoSolid,
  faTruck as faTruckSolid,
  faTruckClock as faTruckClockSolid,
  faTruckContainer as faTruckContainerSolid,
  faUser as faUserSolid,
  faUserPlus as faUserPlusSolid,
  faUsers as faUsersSolid,
  faUserTag as faUserTagSolid,
  faUserTie as faUserTieSolid,
  faImagePortrait as faImagePortraitSolid,
  faBookmark as faBookmarkSolid,
  faExclamationCircle as faExclamationCircleSolid,
  faCloud as faCloudSolid,
  faDatabase as faDatabaseSolid,
  faCamera as faCameraSolid,
  faBrainCircuit as faBrainCircuitSolid,
  faTruckMoving as faTruckMovingSolid,
  faGarageCar as faGarageCarSolid,
  faCircleXmark as faCircleXmarkSolid,
  faFileCode as faFileCodeSolid,
  faArrowRightArrowLeft as faArrowRightArrowLeftSolid,
  faShareNodes as faShareNodesSolid,
  faRight as faRightSolid,
  faLeft as faLeftSolid,
  faLink as faLinkSolid,
  faUnlink as faUnlinkSolid,
  faHighDefinition as faHighDefinitionSolid,
  faStandardDefinition as faStandardDefinitionSolid,
  faArrowLeft as faArrowLeftSolid,
  faRotateRight as faRotateRightSolid,
  faGrid as faGridSolid,
  faAlignLeft as faAlignLeftSolid,
  faAlignCenter as faAlignCenterSolid,
  faAlignRight as faAlignRightSolid,
  faUserTieHair as faUserTieHairSolid,
  faUserTieHairLong as faUserTieHairLongSolid,
  faVirusCovid as faVirusCovidSolid,
  faPersonCane as faPersonCaneSolid,
  faHospital as faHospitalSolid,
  faSatellite as faSatelliteSolid,
  faArrowUpFromBracket as faArrowUpFromBracketSolid,
  faArrowDownToBracket as faArrowDownToBracketSolid,
  faUserCrown as faUserCrownSolid,
  faFilePdf as faFilePdfSolid,
  faFileXls as faFileXlsSolid,
  faGrid2 as faGrid2Solid,
  faGrid4 as faGrid4Solid,
  faArrowRightFromLine as faArrowRightFromLineSolid,
  faArrowRightToLine as faArrowRightToLineSolid,
  faRobot as faRobotSolid,
  faToggleOn as faToggleOnSolid,
  faToggleOff as faToggleOffSolid
} from '@fortawesome/pro-solid-svg-icons'
//endregion

//region Regular icons
import {
  faImage as faImageRegular,
  faTimeline as faTimelineRegular,
  faEnvelope as faEnvelopeRegular,
  faArrowLeftFromLine as faArrowLeftFromLineRegular,
  faBold as faBoldRegular,
  faBoxesStacked as faBoxesStackedRegular,
  faCircle as faCircleRegular,
  faCircleCheck as faCircleCheckRegular,
  faFeather as faFeatherRegular,
  faHotel as faHotelRegular,
  faItalic as faItalicRegular,
  faLink as faLinkRegular,
  faParagraph as faParagraphRegular,
  faTags as faTagsRegular,
  faTimes as faTimesRegular,
  faUnderline as faUnderlineRegular,
  faWarehouse as faWarehouseRegular,
  faFontCase as faFontCaseRegular,
  faArrowUpRightDots as faArrowUpRightDotsRegular,
  faGripVertical as faGripVerticalRegular,
  faClock as faClockRegular,
  faLocationDot as faLocationDotRegular,
  faCloudXmark as faCloudXmarkRegular,
  faChevronDoubleLeft as faChevronDoubleLeftRegular,
  faChevronDoubleRight as faChevronDoubleRightRegular,
  faChevronRight as faChevronRightRegular,
  faChevronLeft as faChevronLeftRegular,
  faCalendar as faCalendarRegular,
  faArrowDownZA as faArrowDownZARegular,
  faArrowDownAZ as faArrowDownAZRegular,
  faArrowUpAZ as faArrowUpAZRegular,
  faWifi as faWifiRegular,
  faBarcode as faBarcodeRegular,
  faBooks as faBooksRegular,
  faRotateRight as faRotateRightRegular,
  faArrowTrendUp as faArrowTrendUpRegular,
  faArrowTrendDown as faArrowTrendDownRegular
} from '@fortawesome/pro-regular-svg-icons'
//endregion

//region Brand icons
import { faSlack } from '@fortawesome/free-brands-svg-icons'
//endregion

//region Light icons
import {
  faLightbulb,
  faKey,
  faFontAwesome,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faAsterisk,
  faFeather,
  faReceipt,
  faStarOfLife,
  faMoneyBills,
  faMoneyBill,
  faBuilding,
  faBuildingColumns,
  faMoneyCheck,
  faNotesMedical,
  faUpRightFromSquare,
  faBasketShopping,
  faRotateRight,
  faAddressBook,
  faAddressCard,
  faAlarmClock,
  faAlarmExclamation,
  faAnalytics,
  faArrowPointer,
  faHourglassStart,
  faHourglassEnd,
  faArchive,
  faArrowAltFromLeft,
  faArrowDownToSquare,
  faArrowLeft,
  faArrowRight,
  faArrowsAltH,
  faArrowsFromLine,
  faArrowsMaximize,
  faArrowsMinimize,
  faArrowSquareDown,
  faFolderArrowDown,
  faArrowUpRightFromSquare,
  faBadgeDollar,
  faBalanceScaleLeft,
  faBars,
  faBan,
  faBell,
  faBellOn,
  faBold,
  faBolt,
  faBook,
  faBookmark,
  faBookOpen,
  faBooks,
  faBullhorn,
  faBox,
  faBoxesStacked,
  faCalculator,
  faCalendar,
  faCalendarAlt,
  faCalendarCircleUser,
  faCalendarClock,
  faCalendarDay,
  faCalendarDays,
  faCalendarMinus,
  faCalendarRange,
  faCalendarWeek,
  faCar,
  faCarGarage,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChurch,
  faCircle,
  faCircleBolt,
  faCircleEuro,
  faCircleChf,
  faCircleInfo,
  faCircleNotch,
  faCirclePlus,
  faCircleXmark,
  faCity,
  faClipboard,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faClone,
  faClosedCaptioning,
  faCloudArrowDown,
  faCloudArrowUp,
  faCodeBranch,
  faCoffinCross,
  faCog,
  faCogs,
  faCrop,
  faCommand,
  faComment,
  faCompressAlt,
  faCopy,
  faCreditCard,
  faCross,
  faDatabase,
  faDiamondTurnRight,
  faDigging,
  faDollarSign,
  faDownload,
  faEdit,
  faChfSign,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEuroSign,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpandArrows,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFamily,
  faFax,
  faFile,
  faFileAlt,
  faFileContract,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFilePdf,
  faFilePen,
  faFilePlus,
  faFilePowerpoint,
  faFiles,
  faFileVideo,
  faFileWord,
  faFileZipper,
  faFilter,
  faFireplace,
  faFolder,
  faFolderMagnifyingGlass,
  faFolderOpen,
  faFolderPlus,
  faFont,
  faGarageCar,
  faGaugeCircleBolt,
  faGridHorizontal,
  faGaugeMax,
  faGlobe,
  faGraduationCap,
  faGridVertical,
  faHandshake,
  faHospital,
  faHotel,
  faHouse,
  faHouseNight,
  faImage,
  faInbox,
  faIndent,
  faInfoSquare,
  faItalic,
  faLandmark,
  faLink,
  faLinkSlash,
  faList,
  faListOl,
  faListTimeline,
  faListUl,
  faLocation,
  faLocationArrow,
  faLocationSlash,
  faLock,
  faLockOpen,
  faLongArrowLeft,
  faMagnifyingGlassLocation,
  faMailbox,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMapMarkerCheck,
  faMapLocation,
  faMessageLines,
  faMessages,
  faMinus,
  faMinusCircle,
  faMobile,
  faMoneyCheckAlt,
  faMoon,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPen,
  faPenCircle,
  faPeopleRoof,
  faPercent,
  faPersonDolly,
  faPhone,
  faPhoneAlt,
  faPiggyBank,
  faPlaneDeparture,
  faPlus,
  faPlusMinus,
  faPollPeople,
  faPrint,
  faPuzzlePiece,
  faQuestion,
  faQuestionCircle,
  faQuestionSquare,
  faQuoteLeft,
  faQuoteRight,
  faRedo,
  faReply,
  faReplyAll,
  faRectangleList,
  faRightLeft,
  faRingsWedding,
  faSearch,
  faShapes,
  faShare,
  faShovel,
  faShuffle,
  faSignIn,
  faSignOut,
  faSitemap,
  faQrcode,
  faSlidersH,
  faSort,
  faSortAlt,
  faSortDown,
  faSortUp,
  faSpinner,
  faSpinnerThird,
  faSquare,
  faSquarePlus,
  faStar,
  faStarfighterAlt,
  faStrikethrough,
  faSun,
  faSwatchbook,
  faSync,
  faSyncAlt,
  faSlidersUp,
  faTable,
  faTag,
  faTags,
  faTasks,
  faTasksAlt,
  faText,
  faTextSize,
  faThumbsUp,
  faTicket,
  faTimes,
  faTombstone,
  faTrash,
  faTruck,
  faTruckClock,
  faTruckMoving,
  faTruckContainer,
  faTv,
  faUnderline,
  faUndo,
  faUndoAlt,
  faUnlock,
  faFlame,
  faUser,
  faUserCircle,
  faUserClock,
  faUserCrown,
  faUserDoctor,
  faUserFriends,
  faUserHardHat,
  faUserHelmetSafety,
  faUserPlus,
  faUsers,
  faUserTie,
  faUserUnlock,
  faWandSparkles,
  faCloud,
  faHeadset,
  faSidebar,
  faSidebarFlip,
  faFileSignature,
  faInputText,
  faPenField,
  faMicrochipAi,
  faMessageSms,
  faMicrophoneStand,
  faCoffin,
  faPeopleCarryBox,
  faPersonCarryBox,
  faVanShuttle,
  faSteeringWheel,
  faWagonCovered,
  faScannerGun,
  faStore,
  faSignature,
  faPenNib,
  faVirusCovid,
  faRectangle,
  faRectangleVertical,
  faTurnLeft,
  faTurnDown,
  faFlower,
  faWallet,
  faThumbsDown,
  faShuttleVan,
  faCarSide,
  faDrone,
  faTableCellsColumns,
  faTimer,
  faTrashUndo,
  faCircleDollarToSlot,
  faArrowDownLeftAndArrowUpRightToCenter,
  faFloppyDisk,
  faStarOfDavid,
  faStarAndCrescent,
  faDove,
  faRoute,
  faAngel,
  faTeddyBear,
  faFlowerTulip,
  faBallotCheck,
  faTree,
  faArrowDown,
  faCloudCheck,
  faCloudSlash,
  faCakeCandles,
  faCalendarCheck,
  faWandMagicSparkles,
  faGrid2,
  faSquareKanban,
  faToggleOn,
  faToggleOff
} from '@fortawesome/pro-light-svg-icons'
//endregion

//region Librarylog
library.add(
  faToggleOn,
  faToggleOff,
  faLightbulb,
  faRobotSolid,
  faCircleDotSolid,
  faToggleOnSolid,
  faToggleOffSolid,
  faCakeCandlesSolid,
  faImageRegular,
  faBasketShopping,
  faRotateRightRegular,
  faRotateRight,
  faUpRightFromSquare,
  faCrosshairsSimpleSolid,
  faRotateRightSolid,
  faCircleDollarToSlot,
  faArrowLeftSolid,
  faRightSolid,
  faReceipt,
  faMoneyBill,
  faLeftSolid,
  faArrowUpRightFromSquareSolid,
  faLinkSolid,
  faUnlinkSolid,
  faAddressBook,
  faAddressCard,
  faHourglassEnd,
  faAlarmClock,
  faAlarmExclamation,
  faAnalytics,
  faArrowPointer,
  faArchive,
  faArrowAltFromLeft,
  faThumbsDown,
  faTimer,
  faCakeCandles,
  faShuttleVan,
  faCarSide,
  faDrone,
  faTableCellsColumns,
  faTruckContainer,
  faTrashUndo,
  faArrowDownToSquare,
  faPenToSquareSolid,
  faArrowLeft,
  faArrowPointerSolid,
  faRotateSolid,
  faArrowRightSolid,
  faArrowRight,
  faArrowsAltH,
  faArrowsFromLine,
  faArrowSquareDown,
  faFolderArrowDown,
  faArrowsRepeatSolid,
  faArrowTurnLeftSolid,
  faArrowUpRightFromSquare,
  faTriangleExclamationSolid,
  faBadgeDollar,
  faBalanceScaleLeft,
  faEnvelopeDotSolid,
  faBars,
  faBan,
  faBell,
  faBellOn,
  faSquare,
  faSquarePlus,
  faBold,
  faHourglassStart,
  faBold,
  faBolt,
  faBook,
  faTimerSolid,
  faBookmark,
  faBookOpen,
  faBooks,
  faBullhorn,
  faBuilding,
  faBox,
  faBoxesStacked,
  faCalculator,
  faCalendar,
  faCalendarAlt,
  faCalendarDay,
  faCalendarCheck,
  faWandMagicSparkles,
  faCalendarDays,
  faCalendarMinus,
  faCalendarCircleUser,
  faCalendarClock,
  faBellSolid,
  faCalendarExclamationSolid,
  faCaretDownSolid,
  faCarGarageSolid,
  faBanSolid,
  faChartBar,
  faThumbsDownSolid,
  faChartLineUpSolid,
  faUserLockSolid,
  faChartNetworkSolid,
  faCheck,
  faCheckCircle,
  faCheckSolid,
  faCreditCardSolid,
  faFileCheckSolid,
  faEnvelopeSolid,
  faEnvelopeCircleSolid,
  faPhoneSolid,
  faPhoneArrowUpRightSolid,
  faPhoneOfficeSolid,
  faCheckSquare,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronDownSolid,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronUpSolid,
  faChurch,
  faCircle,
  faCircleInfo,
  faFamily,
  faRingsWedding,
  faChurchSolid,
  faCircleCheckSolid,
  faCircleNotch,
  faCirclePlus,
  faCircleXmark,
  faCity,
  faCitySolid,
  faClipboard,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faClockSolid,
  faCloneSolid,
  faClone,
  faClosedCaptioning,
  faPlaySolid,
  faCodeBranch,
  faCoffinCross,
  faCoffinSolid,
  faCog,
  faCogs,
  faUserXmarkSolid,
  faCrop,
  faCommand,
  faCommandSolid,
  faComment,
  faCopySolid,
  faCopy,
  faCompressAlt,
  faCreditCard,
  faCross,
  faCrossSolid,
  faDatabase,
  faDiamondTurnRight,
  faDigging,
  faDollarSign,
  faDownload,
  faDownloadSolid,
  faDiamondTurnRightSolid,
  faDroneSolid,
  faEllipsisSolid,
  faEdit,
  faChfSign,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEuroSign,
  faEuroSignSolid,
  faExchangeAltSolid,
  faEyeSolid,
  faEyeSlashSolid,
  faFilePlusSolid,
  faSlashForwardSolid,
  faEnvelopeCircleCheckSolid,
  faCircleEuroSolid,
  faClipboardCheckSolid,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExclamationTriangleSolid,
  faExpandArrows,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFaceSmileSolid,
  faFax,
  faFeatherSolid,
  faFile,
  faFileAlt,
  faFileContract,
  faFileCsv,
  faFileContractSolid,
  faFileExcel,
  faFileExport,
  faHotelSolid,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLinesSolid,
  faFilePdf,
  faFilePen,
  faFilePenSolid,
  faFilterSolid,
  faFilePlus,
  faFilePowerpoint,
  faFiles,
  faFileVideo,
  faFileWord,
  faFileZipper,
  faFilter,
  faFireplace,
  faFireplaceSolid,
  faGarageCar,
  faGearsSolid,
  faFlowerSolid,
  faFlower,
  faWallet,
  faFolder,
  faFolderMagnifyingGlass,
  faFolderOpen,
  faFolderPlus,
  faFont,
  faFont,
  faGaugeMax,
  faCircleBolt,
  faCircleEuro,
  faCircleChf,
  faGlobe,
  faGraduationCap,
  faGridVertical,
  faHandshake,
  faHospital,
  faHotel,
  faHotelRegular,
  faHouse,
  faHouseNight,
  faGaugeCircleBolt,
  faGridHorizontal,
  faHouseNightSolid,
  faImageSolid,
  faIdCardSolid,
  faImage,
  faInbox,
  faIndent,
  faInfoSquare,
  faItalic,
  faItalic,
  faLandmark,
  faFileLines,
  faLink,
  faLinkSlash,
  faList,
  faListCheckSolid,
  faUserPlusSolid,
  faListOl,
  faListOl,
  faListUl,
  faLocation,
  faLocationArrow,
  faLocationSlash,
  faLock,
  faLockOpen,
  faLongArrowLeft,
  faMailbox,
  faMagnifyingGlassLocation,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMapMarkerCheck,
  faMapLocation,
  faMessageLines,
  faMessages,
  faMessageCheckSolid,
  faMicrophoneSolid,
  faMinus,
  faMinusCircle,
  faMobile,
  faMoneyCheckAlt,
  faMoon,
  faMugSolid,
  faNewsPaperSolid,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faParagraph,
  faPen,
  faPenCircle,
  faPeopleArrowsSolid,
  faPeopleCarryBoxSolid,
  faPeopleRoof,
  faPercent,
  faPersonDolly,
  faPhone,
  faPhoneAlt,
  faPiggyBank,
  faPiggyBankSolid,
  faPlaneDeparture,
  faPlaneDepartureSolid,
  faPlus,
  faPlusMinus,
  faPlusSolid,
  faPollPeople,
  faPrint,
  faPrintSolid,
  faPuzzlePiece,
  faQuestion,
  faQuestionCircle,
  faQuestionSquare,
  faQuoteLeft,
  faQuoteRight,
  faRedo,
  faReplySolid,
  faRectangleList,
  faLockOpenSolid,
  faLocationDotSolid,
  faLockSolid,
  faRightLeft,
  faSearch,
  faShapes,
  faShovel,
  faUserCheckSolid,
  faShovelSolid,
  faSignIn,
  faSignOut,
  faSitemap,
  faQrcode,
  faSlidersH,
  faSort,
  faSort,
  faSort,
  faSort,
  faSortAlt,
  faSortDown,
  faSortUp,
  faSpinnerSolid,
  faSliderUpSolid,
  faSpinnerThird,
  faStar,
  faStarfighterAlt,
  faStarOfLifeSolid,
  faStarSolid,
  faStarSolid,
  faSteeringWheelSolid,
  faStrikethrough,
  faUnderline,
  faSun,
  faSwatchbook,
  faSync,
  faSyncAlt,
  faSlidersUp,
  faTag,
  faTags,
  faTagSolid,
  faTagsSolid,
  faTasks,
  faSpinner,
  faTasksAlt,
  faText,
  faTextSize,
  faEnvelopeOpenSolid,
  faThumbsUp,
  faThumbsUpSolid,
  faTicket,
  faTimes,
  faTimesSolid,
  faTimesCircleSolid,
  faTombstone,
  faTombstoneSolid,
  faTrash,
  faTrashSolid,
  faTruck,
  faTruckClock,
  faTruckClockSolid,
  faTruckContainerSolid,
  faTruckSolid,
  faUndo,
  faUndoAlt,
  faUnlock,
  faFlame,
  faUser,
  faUserCircle,
  faUserClock,
  faUserCrown,
  faUserDoctor,
  faUserFriends,
  faUserHardHat,
  faUserHelmetSafety,
  faUserPlus,
  faUsers,
  faUsers,
  faScannerGun,
  faUserSolid,
  faUsersSolid,
  faCircleInfoSolid,
  faCirclePlaySolid,
  faCircleStopSolid,
  faCircleQuestionSolid,
  faFamilySolid,
  faRingsWeddingSolid,
  faAddressBookSolid,
  faAddressCardSolid,
  faUserTagSolid,
  faUserTie,
  faUserTieSolid,
  faUserTieHairSolid,
  faUserTieHairLongSolid,
  faUserUnlock,
  faWandSparkles,
  faPiggyBankSolid,
  faCommentQuestionSolid,
  faFileLinesSolid,
  faMugSolid,
  faPrintSolid,
  faEuroSignSolid,
  faTrashUndoSolid,
  faFlowerSolid,
  faListCheckSolid,
  faCheckSolid,
  faCreditCardSolid,
  faFileCheckSolid,
  faPhoneSolid,
  faEnvelopeSolid,
  faEnvelopeCircleSolid,
  faHourglassClockSolid,
  faHourglassStartSolid,
  faHouseBlankSolid,
  faPlusSolid,
  faCircleCheckSolid,
  faTimesSolid,
  faTimesCircleSolid,
  faStarOfLifeSolid,
  faReplySolid,
  faLockOpenSolid,
  faLockSolid,
  faTombstone,
  faChurch,
  faFireplace,
  faCity,
  faHouseNight,
  faFilter,
  faSort,
  faStarSolid,
  faChartLineUpSolid,
  faChartNetworkSolid,
  faBellSolid,
  faCalendarExclamationSolid,
  faCaretDownSolid,
  faSort,
  faAlarmClock,
  faAlarmClockSolid,
  faTag,
  faArrowsFromLine,
  faFax,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudCheck,
  faCloudSlash,
  faClockRotateLeft,
  faArrowsFromLine,
  faUserHelmetSafety,
  faCirclePlus,
  faPhone,
  faMobile,
  faTruck,
  faArrowDownToSquare,
  faRightLeft,
  faTruckClock,
  faGlobe,
  faStar,
  faTv,
  faArrowsMaximize,
  faArrowsMinimize,
  faTable,
  faListTimeline,
  faReply,
  faReplyAll,
  faShare,
  faCloud,
  faHeadset,
  faSidebar,
  faSidebarFlip,
  faFileSignature,
  faInputText,
  faPenField,
  faMessageSms,
  faMicrophoneStand,
  faCoffin,
  faPeopleCarryBox,
  faPersonCarryBox,
  faShuffle,
  faVanShuttle,
  faSteeringWheel,
  faWagonCovered,
  faCircleRegular,
  faCircleCheckRegular,
  faArrowLeftFromLineRegular,
  faFeatherRegular,
  faBoldRegular,
  faItalicRegular,
  faLinkRegular,
  faUnderlineRegular,
  faParagraphRegular,
  faFontCaseRegular,
  faArrowUpRightDotsRegular,
  faGripVerticalRegular,
  faLocationDotRegular,
  faClockRegular,
  faStore,
  faPenSolid,
  faExclamationTriangleSolid,
  faSpinnerSolid,
  faSliderUpSolid,
  faClockSolid,
  faCloneSolid,
  faCarGarageSolid,
  faTruckSolid,
  faTruckContainerSolid,
  faDroneSolid,
  faEllipsisSolid,
  faPeopleArrowsSolid,
  faPeopleCarryBoxSolid,
  faMessageCheckSolid,
  faMicrophoneSolid,
  faSteeringWheelSolid,
  faPaperClipSolid,
  faPaperPlaneSolid,
  faTagSolid,
  faTagsSolid,
  faNewsPaperSolid,
  faCommandSolid,
  faTrashSolid,
  faFaceSmileSolid,
  faFileContractSolid,
  faShovelSolid,
  faFilePenSolid,
  faFilterSolid,
  faPlaneDepartureSolid,
  faCrossSolid,
  faDownloadSolid,
  faDiamondTurnRightSolid,
  faTruckClockSolid,
  faChurchSolid,
  faCitySolid,
  faFireplaceSolid,
  faTombstoneSolid,
  faHouseNightSolid,
  faImageSolid,
  faIdCardSolid,
  faArrowPointerSolid,
  faArrowsRepeatSolid,
  faArrowTurnLeftSolid,
  faArrowRightSolid,
  faCalendarPenSolid,
  faCircleSolid,
  faCalendarRange,
  faCalendarWeek,
  faCarGarage,
  faCar,
  faTimesRegular,
  faCheckSquareSolid,
  faWarehouseRegular,
  faTagsRegular,
  faBoxesStackedRegular,
  faImagePortraitSolid,
  faBookmarkSolid,
  faExclamationCircleSolid,
  faCloudSolid,
  faDatabaseSolid,
  faCameraSolid,
  faBrainCircuitSolid,
  faGarageCarSolid,
  faTruckMovingSolid,
  faCircleXmarkSolid,
  faFileCodeSolid,
  faArrowRightArrowLeftSolid,
  faShareNodesSolid,
  faHighDefinitionSolid,
  faStandardDefinitionSolid,
  faGridSolid,
  faAlignLeftSolid,
  faAlignCenterSolid,
  faAlignRightSolid,
  faMicrochipAi,
  faSignature,
  faSlack,
  faCloudXmarkRegular,
  faPenNib,
  faChevronDoubleLeftRegular,
  faChevronDoubleRightRegular,
  faChevronRightRegular,
  faChevronLeftRegular,
  faCalendarRegular,
  faArrowDownZARegular,
  faArrowDownAZRegular,
  faArrowUpAZRegular,
  faWifiRegular,
  faBarcodeRegular,
  faVirusCovid,
  faVirusCovidSolid,
  faLocationPinSolid,
  faPersonCaneSolid,
  faFireFlameSimpleSolid,
  faFolderBookmarkSolid,
  faHospitalSolid,
  faRectangle,
  faRectangleVertical,
  faTurnLeft,
  faTurnDown,
  faTruckMoving,
  faTruckContainer,
  faSatelliteSolid,
  faBooksRegular,
  faTimelineRegular,
  faEnvelopeRegular,
  faMoneyBills,
  faBuilding,
  faBuildingColumns,
  faMoneyCheck,
  faNotesMedical,
  faStarOfLife,
  faArrowUpRightAndArrowDownLeftFromCenterSolid,
  faEarthEuropeSolid,
  faSignatureSolid,
  faFeather,
  faAsterisk,
  faArrowDownLeftAndArrowUpRightToCenter,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownToBracketSolid,
  faArrowUpFromBracketSolid,
  faArrowTrendDownRegular,
  faArrowTrendUpRegular,
  faArrowsUpDownLeftRightSolid,
  faMailboxSolid,
  faFloppyDisk,
  faUserCrownSolid,
  faFileXlsSolid,
  faFilePdfSolid,
  faGrid4Solid,
  faGrid2Solid,
  faStarOfDavid,
  faStarAndCrescent,
  faDove,
  faAngel,
  faRoute,
  faTeddyBear,
  faFlowerTulip,
  faBallotCheck,
  faTree,
  faArrowDown,
  faFontAwesome,
  faArrowRightToLineSolid,
  faArrowRightFromLineSolid,
  faKey,
  faGrid2,
  faSquareKanban
)
//endregion

export default (app) => {
  app.component('FontAwesomeIcon', FontAwesomeIcon)
}
